// Loader.jsx
import React from "react";
import "./Loader.scss"; // Import the SCSS file

const Loader = () => {
  return (
    <div className="loader">
      <div className="loader__spinner"></div>
    </div>
  );
};

export default Loader;
